var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownRepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1668_22768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34362 11.6481C8.41686 11.7544 8.51487 11.8414 8.6292 11.9015C8.74352 11.9616 8.87074 11.993 8.9999 11.993C9.12906 11.993 9.25628 11.9616 9.37061 11.9015C9.48494 11.8414 9.58294 11.7544 9.65619 11.6481L16.8418 1.26881C16.925 1.14909 16.9738 1.00887 16.9828 0.863384C16.9919 0.717894 16.961 0.572699 16.8933 0.443574C16.8257 0.314448 16.7239 0.206332 16.5991 0.13097C16.4743 0.0556087 16.3313 0.0158847 16.1855 0.0161143H1.81427C1.66884 0.016715 1.52632 0.0569499 1.40204 0.132492C1.27777 0.208034 1.17643 0.316025 1.10894 0.444851C1.04145 0.573678 1.01035 0.718466 1.01899 0.863644C1.02763 1.00882 1.07569 1.1489 1.15799 1.26881L8.34362 11.6481Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1668_22768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownRepo);
export default __webpack_public_path__ + "static/media/ic_down-repo.aca981481b1208c41a231eda3bb13cdb.svg";
export { ForwardRef as ReactComponent };